import type { Template } from "@/types";

export const PO_04_H2_V2: Template[] = [
    {
        id: "po-04-h2v2-01",
        name: "PO 01 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 14, y: 306, width: 203, height: 305, rotation: 0, imageRotation: 0 },
            { id: "2", x: 225, y: 306, width: 458, height: 305, rotation: 0, imageRotation: 0 },
            { id: "3", x: 692, y: 306, width: 458, height: 305, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1158, y: 306, width: 203, height: 305, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-02",
        name: "PO 02 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 120, y: 123, width: 448, height: 672, rotation: 0, imageRotation: 0 },
            { id: "2", x: 729, y: 123, width: 602, height: 373, rotation: 0, imageRotation: 0 },
            { id: "3", x: 729, y: 503, width: 195, height: 291, rotation: 0, imageRotation: 0 },
            { id: "4", x: 932, y: 503, width: 399, height: 291, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-03",
        name: "PO 03 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 687, height: 916, rotation: 0, imageRotation: 0 },
            { id: "2", x: 776, y: 172, width: 507, height: 315, rotation: 0, imageRotation: 0 },
            { id: "3", x: 776, y: 495, width: 164, height: 250, rotation: 0, imageRotation: 0 },
            { id: "4", x: 948, y: 495, width: 336, height: 250, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-04",
        name: "PO 04 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 43, y: 233, width: 300, height: 450, rotation: 0, imageRotation: 0 },
            { id: "2", x: 351, y: 233, width: 300, height: 450, rotation: 0, imageRotation: 0 },
            { id: "3", x: 805, y: 154, width: 450, height: 300, rotation: 0, imageRotation: 0 },
            { id: "4", x: 805, y: 462, width: 450, height: 300, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-05",
        name: "PO 05 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_05.png",
        size: [1374, 916],
        style: {},
        slots: [          
            { id: "1", x: 14, y: 306, width: 458, height: 305, rotation: 0, imageRotation: 0 },
            { id: "2", x: 480, y: 306, width: 203, height: 305, rotation: 0, imageRotation: 0 },
            { id: "3", x: 691, y: 306, width: 203, height: 305, rotation: 0, imageRotation: 0 },
            { id: "4", x: 902, y: 306, width: 458, height: 305, rotation: 0, imageRotation: 0 }     
        ],
    },

    {
        id: "po-04-h2v2-06",
        name: "PO 06 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 92, y: 194, width: 787, height: 528, rotation: 0, imageRotation: 0 },
            { id: "2", x: 887, y: 194, width: 394, height: 260, rotation: 0, imageRotation: 0 },
            { id: "3", x: 887, y: 462, width: 193, height: 261, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1088, y: 462, width: 193, height: 261, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-07",
        name: "PO 07 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_07.png",
        size: [1374, 916],
        style: {},
        slots: [        
            { id: "1", x: 86, y: 174, width: 376, height: 568, rotation: 0, imageRotation: 0 },
            { id: "2", x: 470, y: 462, width: 434, height: 280, rotation: 0, imageRotation: 0 },
            { id: "3", x: 470, y: 174, width: 434, height: 280, rotation: 0, imageRotation: 0 },
            { id: "4", x: 912, y: 174, width: 376, height: 568, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-04-h2v2-08",
        name: "PO 08 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 86, y: 174, width: 376, height: 568, rotation: 0, imageRotation: 0 },
            { id: "2", x: 470, y: 174, width: 376, height: 568, rotation: 0, imageRotation: 0 },
            { id: "3", x: 854, y: 174, width: 435, height: 280, rotation: 0, imageRotation: 0 },
            { id: "4", x: 854, y: 462, width: 435, height: 280, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-09",
        name: "PO 09 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 288, y: 92, width: 548, height: 362, rotation: 0, imageRotation: 0 },
            { id: "2", x: 843, y: 92, width: 244, height: 362, rotation: 0, imageRotation: 0 },
            { id: "3", x: 288, y: 462, width: 244, height: 362, rotation: 0, imageRotation: 0 },
            { id: "4", x: 540, y: 462, width: 547, height: 362, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-10",
        name: "PO 10 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 67, y: 177, width: 408, height: 277, rotation: 0, imageRotation: 0 },
            { id: "2", x: 67, y: 462, width: 200, height: 275, rotation: 0, imageRotation: 0 },
            { id: "3", x: 275, y: 462, width: 200, height: 275, rotation: 0, imageRotation: 0 },
            { id: "4", x: 483, y: 177, width: 824, height: 560, rotation: 0, imageRotation: 0 }
        ],
    },
];